<h2 mat-dialog-title id="dialog-upload-success-title">{{ 'upload.success.title' | translate }}</h2>
<div mat-dialog-content id="dialog-upload-success-content">
  <ng-container *ngIf="results.length === 1">
    <p id="dialog-upload-success-message">
      <span>{{ 'upload.success.message' | translate:{name: results[0].document_name, folder: results[0].folder_name} }}</span>
    </p>
    <ng-container *ngIf="results[0].task_id">
      <div style="margin-top: 1.5em; display: flex; align-items: center; gap: 1em;">
        <a href="#"
           (click)="goToTask(results[0].task_id); $event.preventDefault();"
           matTooltip="Task ID: {{ results[0].task_id }}"
          style="color: var(--link); text-decoration: underline; font-weight: 500; font-size: 1.08em;"
        >
          Revisa cómo va el procesamiento de su documento
        </a>
        <button mat-stroked-button color="primary" (click)="copyTaskId(results[0].task_id)" [matTooltip]="copiedTaskId === results[0].task_id ? '¡Copiado!' : 'Copiar Task ID'" style="padding: 0 12px; min-width: 0;">
          <i class="fas fa-copy"></i>
        </button>
      </div>
    </ng-container>
    <div *ngIf="results[0].message" style="margin-top: 0.5em; color: #4caf50; font-weight: 500;">{{ results[0].message }}</div>
  </ng-container>

  <ng-container *ngIf="results.length > 1">
    <p id="dialog-upload-success-message-multi">
      <span>{{ 'upload.success.multi_message' | translate:{count: results.length} }}</span>
    </p>
    <ul style="margin: 1em 0 0 0; padding: 0 0 0 1.2em;">
      <li *ngFor="let r of results">
        <span style="font-weight: 500;">{{ r.document_name }}</span>
        <span *ngIf="r.folder_name"> ({{ r.folder_name }})</span>
        <span *ngIf="r.message" style="color: #4caf50; margin-left: 0.5em;">{{ r.message }}</span>
        <ng-container *ngIf="r.task_id">
          <a href="#" (click)="goToTask(r.task_id); $event.preventDefault();" matTooltip="Task ID: {{ r.task_id }}" style="color: var(--link); text-decoration: underline; font-weight: 500; margin-left: 0.7em;">Ver tarea</a>
          <button mat-stroked-button color="primary" (click)="copyTaskId(r.task_id)" [matTooltip]="copiedTaskId === r.task_id ? '¡Copiado!' : 'Copiar Task ID'" style="padding: 0 10px; min-width: 0; margin-left: 0.3em;">
            <i class="fas fa-copy"></i>
          </button>
        </ng-container>
      </li>
    </ul>
  </ng-container>
</div>
<div mat-dialog-actions align="end" id="dialog-upload-success-actions">
  <button mat-flat-button mat-dialog-close color="primary" id="dialog-upload-success-close">{{ 'common.close' | translate }}</button>
</div>
